import prop from 'ramda/src/prop'
import reduce from 'ramda/src/reduce'
import equals from 'ramda/src/equals'
import isEmpty from 'ramda/src/isEmpty'

import createRecordClickActionStoreKey from 'root/src/client/logic/api/util/createRecordClickActionStoreKey'

import initApiRecordClickActionRequest from 'root/src/client/logic/api/actions/initApiRecordClickActionRequest'
import apiRecordClickActionRequestSuccess from 'root/src/client/logic/api/actions/apiRecordClickActionRequestSuccess'
import apiRecordClickActionRequestError from 'root/src/client/logic/api/actions/apiRecordClickActionRequestError'
import generalRecordModification from 'root/src/client/logic/api/actions/generalRecordModification'
import recordClickActionDescriptions from 'root/src/shared/descriptions/recordClickActions'

import recordClickActionValidation from 'root/src/client/logic/api/util/recordClickActionValidation'

import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import subObj from 'root/src/shared/util/subObj'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { lookupErrorMessage } from 'root/src/client/logic/form/actions/submitFormError'

export default (
	recordClickActionId,
	recordId,
	actionPayload,
	noVerification,
	// eslint-disable-next-line consistent-return
) => async (dispatch, getState) => {
	try {
		const recordClickActionStoreKey = createRecordClickActionStoreKey(
			recordClickActionId, recordId,
		)
		dispatch(initApiRecordClickActionRequest(recordClickActionStoreKey))
		const state = getState()
		const {
			endpointId, payloadMap, onSuccessRecordUpdates, validation, onSuccessRedirect,
			verificationFn,
		} = prop(recordClickActionId, recordClickActionDescriptions)
		const payloadSubs = { recordId }

		const payload = subObj(payloadSubs, payloadMap, actionPayload)

		if (validation) {
			const validationErrors = reduce((result, validationObj) => {
				const nextErr = recordClickActionValidation(validationObj, payload)
				return { ...result, ...nextErr }
			}, {}, validation)
			if (!isEmpty(validationErrors)) {
				return dispatch(
					apiRecordClickActionRequestError(
						recordClickActionStoreKey, validationErrors,
					),
				)
			}
		}
		if (!noVerification && verificationFn) {
			const stopExacution = verificationFn({
				recordClickActionId,
				recordId,
				actionPayload,
				state,
				dispatch,
			})
			if (stopExacution) {
				dispatch(
					apiRecordClickActionRequestSuccess(recordClickActionStoreKey),
				)
				// eslint-disable-next-line consistent-return
				return
			}
		}
		const lambdaRes = await invokeApiRequest(endpointId, payload, state)
		const { statusCode, body, statusError, generalError } = lambdaRes
		if (equals(statusCode, 200)) {
			dispatch(
				apiRecordClickActionRequestSuccess(
					recordClickActionStoreKey, body,
				),
			)
			if (onSuccessRecordUpdates) {
				dispatch(generalRecordModification(
					{ recordStoreKey: recordId },
					onSuccessRecordUpdates,
				))
			}
			if (onSuccessRedirect) {
				const { routeId, routeParams } = onSuccessRedirect

				return pushRouteClient({ routeId, routeParams })
			}
		} else { // else creating, don't need record error state
			const lambdaError = lookupErrorMessage(lambdaRes, [
				['message'],
				['error'],
				['error', 'error'],
				['error', 'message'],
				['error', 'message', 'message'],
			])
			const error = {
				...statusError,
				...generalError,
				...(lambdaError ? { message: lambdaError } : {}),
			}
			dispatch(
				apiRecordClickActionRequestError(
					recordClickActionStoreKey, error,
				),
			)
		}
		return lambdaRes
	} catch (e) {
		console.warn(e)
	}
}
